import * as React from "react";

/**
 * Figma Node IDs:
 * Design Frame: 9174:6403
 * Instance IDs: 9174:6404, 9174:6409, 9174:6414, 9174:6419, 9174:6425, 9174:6430, 9174:6435, 9174:6440, 9174:6524, 9174:6528, 9174:6532, 9174:6536, 9174:6483, 9174:6446, 9174:6451, 9174:6456, 9174:6462, 9174:6467, 9174:6472, 9174:6477, 9174:6547, 9174:6551, 9174:6555, 9174:6559
 * Composite: false
 * Last Updated: 2026-03-31
 * Generated by: Claude Code figma-component command
 */

import { ExternalLink } from "@labxchange/icons";
import { RichText } from "@learningblocks/shared-components/lib/RichText";

import * as styles from "./TextLink.css";

export interface TextLinkProps {
  // Required props without defaults
  children: React.ReactNode;
  href: string;

  // Optional props without defaults
  className?: string;
  testId?: string;

  // Props with defaults
  type?: "default" | "onColor";
  opensInNewTab?: boolean;
}

export const TextLink = ({
  children,
  href,
  className,
  testId,
  type = "default",
  opensInNewTab = false,
}: TextLinkProps) => {
  const linkProps = opensInNewTab
    ? {
        target: "_blank",
        rel: "noopener noreferrer",
      }
    : {};

  return (
    <a
      href={href}
      className={`${styles.textLink}${className ? ` ${className}` : ""}`}
      data-type={type}
      data-testid={testId}
      {...linkProps}
    >
      <span className={styles.textContent}>
        {typeof children === "string" ? (
          <RichText value={children} />
        ) : (
          children
        )}
      </span>
      {opensInNewTab && (
        <ExternalLink
          className={styles.externalIcon}
          aria-label="opens in new tab"
        />
      )}
    </a>
  );
};
